<template>
<span v-if="isVisible()" id="change-ship-date-cooler-inventory-dialog-section">
  <el-tooltip class="item" effect="dark" :enterable="false" :content="$t('coolerInventory.changeShipDate')" placement="top-start">
        <i class="icon-action el-icon-date" type="success" size="mini" @click="handleOpen"></i>
  </el-tooltip>
  <el-dialog
    :close-on-click-modal="false"
    v-on:open="handleOpen"
    :title="$t('coolerInventory.changeShipDate')"
    :visible.sync="dialogVisible"
    id="change-ship-date-cooler-inventory-dialog"
    width="34%"
    v-on:closed="$emit('close-dialog')">
    <el-form :model="changeShipDateform" :rules="formRules" ref="changeShipDateform" label-position="right" size="mini" inline class="text-align-end">
        <el-row>
          <div class= "change-shipdate">
            <span>{{ `${coolerInventoryObject.numberUnits} ${$t('coolerInventory.totalUnitsChangeShipDate')} [${coolerInventoryObject.dimensions}]` }} </span>
          </div>
          <div class= "change-shipdate">
            <span>{{ `${$t('coolerInventory.shipperChangeShipDate')} ${coolerInventoryObject.shipperAccountName}`}} </span>
          </div>
          <div class= "change-shipdate">
            <span>{{ `${$t('coolerInventory.consigneeChangeShipDate')} ${coolerInventoryObject.consigneeAccountName}`}} </span>
          </div>
          <el-row>
            <div class="change-shipdate">
              <el-form-item :label="$t('coolerInventory.newShipDate')" prop="newShipDate">
                  <el-date-picker
                  v-model="changeShipDateform.newShipDate"
                  format="MM/dd/yyyy"
                  :picker-options="shipDatePickerOptions"
                  type="date"
                  id="changeShipDateform-new-ship-date"
                  ref="changeShipDatePicker">
                  </el-date-picker>
              </el-form-item>
            </div>
          </el-row>
        </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer form-vertical-item flex-reverse-direction">
      <el-button type="primary" @click="handleChangeShipDate" size="mini" class="margin-r-18" id="btn-change-ship-date-move">{{ $t('common.move') }}</el-button>
      <el-button @click="dialogVisible = false" size="mini">{{ $t('common.cancel') }}</el-button>
    </div>
  </el-dialog>
</span>
</template>

<script>
import moment from 'moment';
import { Message } from 'element-ui';
import { mapGetters } from 'vuex';
import constants from '@/utils/constants';

export default {
  props: {
    coolerInventoryObject: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters(['coolerInventory'])
  },
  data() {
    return {
      dialogVisible: false,
      changeShipDateform: {
        newShipDate: null,
        coolerInventoryId: null
      },
      formRules: {
        newShipDate: [
          { required: true, message: this.$t('outbound.units.newShipDateRequired'), trigger: 'blur' }
        ]
      },
      shipDatePickerOptions: {}
    };
  },
  methods: {
    handleOpen() {
      this.dialogVisible = true;
      this.changeShipDateform.coolerInventoryId = this.coolerInventoryObject.coolerId;
      this.changeShipDateform.newShipDate = null;
      this.shipDatePickerOptions = {
        disabledDate(time) {
          const momentTime = moment(time.getTime());
          return momentTime.isBefore(moment(), 'day');
        }
      };
      this.$nextTick(() => {
        this.$refs.changeShipDatePicker.focus();
      });
    },
    async handleChangeShipDate() {
      const valid = await this.$refs.changeShipDateform.validate().catch(() => {});
      if (!valid) {
        return;
      }

      // Close previous messages and show loading
      Message.closeAll();
      const loading = this.$loading(constants.LOADING.CHANGE_SHIPDATE_CONFIG);

      // Call action to changeShipDate
      try {
        await this.$store.dispatch('coolerInventory/changeShipDate', this.changeShipDateform).catch(() => {});
        await this.$store.dispatch('coolerInventory/search', {});
        this.dialogVisible = false;
      } finally {
        loading.close();
      }
    },
    isVisible() {
      const isOpen = this.coolerInventoryObject.coolerStatus === constants.COOLER_INVENTORY.STATUS[1].value;
      const hasChangeShipmentPermission = this.$can(this.permissions.OUTBOUND.CHANGE_SHIP_DATE);
      return isOpen && hasChangeShipmentPermission;
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">

#change-ship-date-cooler-inventory-dialog {
  input.el-input__inner {
    padding-left: 30px;
  }
  .change-shipdate {
    text-align: left !important;
    margin-bottom: 10px;
  }
}

</style>
